<template>
  <v-list :class="['item-content', notification.itWasRead && (type === 'myNotifications' || type === 'archiveNotifications' || type === 'distributionNotifications') ? 'notWasRead' : '']">
    <v-list-item-action :rounded="false" v-if="type === 'adminNotifications' || type === 'myNotifications'">
        <v-checkbox
            v-model="notification.selected"
            color="primary"
        ></v-checkbox>
    </v-list-item-action>

    <v-list-item-content :rounded="false" @click.prevent="rowClicked(notification.demand.objectId)">
        <v-list-item-title>{{ notification.client ? notification.client.name : 'oi' }}</v-list-item-title>
        <v-list-item-subtitle class="text--primary">{{ `${$t('notifications.tile.demand')}: ${(notification.demand) ? notification.demand.demand : this.$t('notifications.tile.demandNotFound')}` }}</v-list-item-subtitle>
        <v-list-item-subtitle>
            <span v-html="notification.message"></span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="type === 'adminNotifications'" class="font-italic">{{ `${$t('notifications.tile.lastSeen')}: ${viewedAt}` }}</v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action class="display-flex justify-center">
      <div class="notification-actions" v-if="type !== 'distributionNotifications'">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="type === 'adminNotifications' || type === 'adminArchiveNotifications' ? adminStored(notification.objectId, !notification.adminsStored) : setStored(notification.objectId)"
                >
                    <v-icon>archive</v-icon>
                </v-btn>
            </template>
            <span v-if="type === 'myNotifications' || type === 'archiveNotifications'">{{notification.usersStored ? $t('notifications.tile.archiveActions.unarchive') : $t('notifications.tile.archiveActions.archive')}}</span>
            <span v-if="type === 'adminNotifications' || type === 'adminArchiveNotifications'">{{notification.adminsStored ? $t('notifications.tile.archiveActions.unarchive') : $t('notifications.tile.archiveActions.archive')}}</span>
        </v-tooltip>

         <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    v-if="type === 'myNotifications' || type === 'archiveNotifications'"
                >
                    <v-icon v-if="notification.itWasRead" @click.prevent="setRead(notification.objectId, false)">drafts</v-icon>
                    <v-icon v-else @click.prevent="setRead(notification.objectId, true)">email</v-icon>
                </v-btn>
            </template>
            <span>{{notification.itWasRead ? $t('notifications.tile.readActions.markUnread') : $t('notifications.tile.readActions.markRead') }}</span>
        </v-tooltip>
      </div>
      <v-list-item-action-text :class="[type === 'adminNotifications' || type === 'myNotifications' ? 'notification-date' : '']" v-text="date"></v-list-item-action-text>
    </v-list-item-action>
  </v-list>
</template>

<script>
import API from '@/api'

export default {
    name: 'notification-item',
    props: ['notification', 'type', 'teste'],
    data () {
        return {
            houver: false
        }
    },
    computed: {
        date: function () {
            if (new Date(this.notification.createdAt).getFullYear() === new Date().getFullYear()) {
                return this.formatDate(new Date(this.notification.createdAt), true)
            } else {
                return this.formatDate(new Date(this.notification.createdAt), true)
            }
        },
        viewedAt: function () {
            if (this.notification.demand.viewedAt && this.notification.demand.viewedAt !== null) {
                return this.formatDate(new Date(this.notification.demand.viewedAt.iso), false)
            }
            return this.$t('notifications.tile.neverSeen')
        }
    },
    methods: {
        adminStored (id, value) {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let endpoint = API.EndPoints.setNotification
            let params = {
                action: 'adminStore',
                id: id,
                value: value,
                organizationId: currentUserCompany.client.objectId
            }

            new API(endpoint, params).request().then(response => {
                this.$emit('filterNotifications', id)
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        setRead (id, value) {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let endpoint = API.EndPoints.setNotification
            let params = {
                action: 'read',
                id: id,
                value: value,
                organizationId: currentUserCompany.client.objectId
            }

            new API(endpoint, params).request().then(response => {
                this.notification.itWasRead = !this.notification.itWasRead
                window.getApp.refreshBadgeNotifications = true
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        setStored (id) {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let endpoint = API.EndPoints.setNotification
            let params = {
                action: 'store',
                id: id,
                organizationId: currentUserCompany.client.objectId
            }

            new API(endpoint, params).request().then(response => {
                this.$emit('filterNotifications', id)
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async rowClicked (id) {
            if (!this.notification.itWasRead) await this.setRead(this.notification.objectId, true)
            this.$emit('saveSelected')
            let params = {
                id: id,
                requesterType: 'notificacoes'
            }
            this.$router.push({ name: 'NotificacaoDetalheDemanda', params: params }).catch(e => {})
        },
        formatDate (date, dateOnly) {
            const day = date.getDate().toString()
            const dayF = (day.length === 1) ? '0' + day : day
            const month = (date.getMonth() + 1).toString()
            const monthF = (month.length === 1) ? '0' + month : month
            const yearF = date.getFullYear()
            if (dateOnly) return dayF + '/' + monthF + '/' + yearF
            const hourF = date.getHours()
            const minuteF = date.getMinutes()
            return dayF + '/' + monthF + '/' + yearF + ' ' + hourF + ':' + minuteF
        }
    }
}
</script>

<style lang="stylus" scoped>
  .item-content
    display: flex;
    width: 100%;
    border-bottom: 1px solid #C9C9C9;
    border-radius: 0;
    padding: 0 16px;

  .notification-actions
    display: none;

  .notWasRead
    background-color: #EAEAEA;

  .item-content:hover
    border: 1px solid #A9A9A9;
    cursor: pointer;
    display: flex;
    justify-content: center;
    .notification-actions
      display: block;
    .notification-date
      display: none;
</style>
